import { useSelector } from 'react-redux';
import type { SessionProps } from '@bimone/bimtrack-core';
import { ApplicationState } from '../redux/store';
import { useMemo } from 'react';
import { Session } from '@bimone/bimtrack-core';

export function useSession(): Session {
  const session = useSelector<ApplicationState, SessionProps>(state => state.session);

  return useMemo(() => {
    return new Session({
      user: session.user,
      hub: session.hub,
      project: session.project,
      bimTrackApiUrl: session.bimTrackApiUrl,
    });
  }, [session.user, session.hub, session.project, session.bimTrackApiUrl]);
}
